import { IEvent, EventMap } from "./types";

export const parseEvent = <T extends keyof EventMap>(
  type: T,
  data: EventMap[T]
): IEvent<T> => {
  return { type, data };
};
